import type { ProviderName } from '../types';

const READ_SCOPES: Record<ProviderName, string> = {
  google: 'https://www.googleapis.com/auth/gmail.readonly',
  microsoft: 'https://graph.microsoft.com/Mail.Read',
};

const SEND_SCOPES: Record<ProviderName, string> = {
  google: 'https://www.googleapis.com/auth/gmail.send',
  microsoft: 'https://graph.microsoft.com/Mail.Send',
};

export function scopesFor(provider: ProviderName, canSendEmail = false): string[] {
  const scopes = [READ_SCOPES[provider]];
  if (canSendEmail) scopes.push(SEND_SCOPES[provider]);
  return scopes;
}
